import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import styled from "styled-components";

import Card from "./Card";
import RevitParameterTemplates from "./RevitParameterTemplates.graphql";
import { parameterSearch as parameterSearchModule } from "../../../../modules/shared-entities";
import { FluidAccent } from "../../../../modules/ui-kit";

export const Component = styled(Card)`
    align-items: flex-start;
    color: #000;
    flex-direction: column;
    gap: 8px;

    & > div:first-of-type {
        position: relative;
    }

    & > div:last-of-type {
        align-self: stretch;
        display: grid;
        grid-auto-columns: minmax(0, 1fr);
        grid-auto-flow: column;
    }

    ${ FluidAccent }
`;

export const name = "RevitParameterTemplate";

export function getID(entity) {
    return entity.id;
}

export function useSearch(token: string) {
    const [execute, { called, data, error, loading }] = useLazyQuery(
        gql(RevitParameterTemplates),
    );

    const parameterSearch = parameterSearchModule.useSearch(token);

    useEffect(
        () => {
            if (token.length < 3) return;

            if (!called) {
                void execute();
            }
        },
        [called, token],
    );

    const [results, setResults] = useState(undefined);

    useEffect(
        () => {
            if (token.length > 2 && data) {
                setResults(
                    parameterSearch
                        .results
                        .map(
                            (parameter) => data.revitParameterTemplates.find(
                                (rpd) => rpd.parameterID === parameter.id
                            )
                        )
                        .filter(Boolean)
                );
            } else {
                setResults([]);
            }
        },
        [data, parameterSearch.results, token],
    );

    return {
        error: error ?? parameterSearch.error,
        loading: loading || parameterSearch.loading,
        results,
    };
}
